import Spinner from 'react-bootstrap/Spinner';

function LoadingProgress({hidden}) {
  return (
    <Spinner hidden={hidden} animation="border" role="status">
    </Spinner>
  );
}

export default LoadingProgress;